export default class Payment {
  constructor(reservation, paymentId, creditCardUrl) {
    this.reservation = reservation;
    this.id = paymentId;
    this.creditCardUrl = creditCardUrl;
  }
}